import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updadteHeightVordaecher,
        updateWidthVordaecher,
        updateStepsVordaecher
        } from '../../../../store/actions/vordaecher';
import TextField from '@material-ui/core/TextField';
import scrollToElement from '../../../../module/scrollToElement';


const Step_1 = (props) => {
   const [height, updateHeight] = useState(0);
   const [height_param, updateHeightParam] = useState('');
   const [width, update_Width] = useState(0);
   const [width_param, updateWidthParam] = useState('');

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      const {height, height_param, width, width_param} = props.data[props.modell_index].dimensions[0];
      let titel = props.data[props.modell_index].titel;
      let modal_box_header = document.querySelector('#modal_box_header');

      modal_box_header.innerHTML = titel;

      updateHeight(height);
      updateHeightParam(height_param);
      update_Width(width);
      updateWidthParam(width_param);

      //update steps
      props.updateSteps(0);

      //scroll to Next Button Container
      if (Number(height)>=Number(height_param.substring(0,2)) && Number(width)>=Number(width_param.substring(0,2))) scrollToElement();

      //Weiter-Button aktivieren
      if((Number(height)>=Number(height_param.substring(0,2)) && Number(width)>=Number(width_param.substring(0,2))) || props.data[props.modell_index].allVisitedSteps) {
         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue();
         props.updateSteps(1);
      }

   }

   const updadteHeight = ev => {
      props.updadteHeight(ev.target.value);
      updateItems();
   }

   const updateWidth = ev => {
      props.updateWidth(ev.target.value);
      updateItems();
   }


       return (
           <div className="step_wrapper">
             <h2 className="step_header">Wie sind Ihre Maße für das Vordach?</h2>
              <div className="step_icon_wrapper">
                 <div className="inner_masseMenge_wrapper">
                  <div className="textfield-wrapper">
                        <TextField
                           className="textfield-masse-quantity"
                           label={`Breite (ab ${width_param} cm)`}
                           type="number"
                           rowsMax={1}
                           value={width}
                           name="width"
                           onChange={updateWidth}
                        >
                     </TextField>
                     <TextField
                           className="textfield-masse-quantity"
                           label={`Tiefe (ab ${height_param} cm)`}
                           type="number"
                           rowsMax={1}
                           value={height}
                           name="height"
                           onChange={updadteHeight}
                        >
                     </TextField>
                  </div>
                </div>
            </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
      modell_index: state.vordaecherReducer.modell_index,
      data: state.vordaecherReducer.data

    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updadteHeight: ev => dispatch(updadteHeightVordaecher(ev)),
      updateWidth: ev => dispatch(updateWidthVordaecher(ev)),
      updateSteps: ev => dispatch(updateStepsVordaecher(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_1);
